import styled from "styled-components";

export const LoadingDiv = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  align-items: center;
  z-index: 2;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;
